import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import classnames from 'classnames';
import { LiraAdvContainer } from '@sbt-web/adv';
import gridStyles from '@/client/components/Detail/Containers/style/grid.module.scss';
let alreadyFetched = false;
export const LiraLazySlotVehicleHistory = t0 => {
  const $ = _c(9);
  const {
    containerId,
    cssClass
  } = t0;
  let t1;
  if ($[0] !== containerId) {
    t1 = () => {
      if (!alreadyFetched) {
        alreadyFetched = true;
        window.liraSDKQueue?.push(() => {
          window.liraSdk.fetchLazyLoadAd([containerId]);
        });
      }
    };
    $[0] = containerId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: "100px"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cssClass) {
    t4 = classnames(gridStyles["detail-component"], cssClass);
    $[4] = cssClass;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== containerId || $[7] !== t4) {
    t5 = <div style={t3}><LiraAdvContainer className={t4} idForAd={containerId} /></div>;
    $[6] = containerId;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};